import React, { useState, useEffect } from 'react';
import { Bell, BellOff, BellRing } from 'lucide-react';
import { toast } from 'sonner';
import { enablePush, disablePush, sendTestPush, getExistingSubscription, pushSupported, isIOS, isStandalone } from '../push';
import { API, useAuth } from '../App';

export const PushToggle = () => {
  const { token } = useAuth();
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getExistingSubscription().then((s) => setOn(!!s)).catch(() => {});
  }, []);

  const toggle = async () => {
    if (busy) return;
    setBusy(true);
    try {
      if (on) {
        await disablePush(API, token);
        setOn(false);
        toast.success('Push alerts disabled on this device');
      } else {
        await enablePush(API, token);
        setOn(true);
        toast.success('Push alerts enabled — booth outages & payment alerts will reach this device');
      }
    } catch (e) {
      toast.error(e.message);
    }
    setBusy(false);
  };

  const test = async (e) => {
    e.stopPropagation();
    try {
      await sendTestPush(API, token);
      toast.success('Test notification sent');
    } catch (err) {
      toast.error(err.message);
    }
  };

  if (!pushSupported() && !(isIOS() && !isStandalone())) return null;

  return (
    <button
      onClick={toggle}
      className={`w-full px-4 py-2 rounded-lg transition-all text-sm mb-2 flex items-center justify-between gap-2 ${
        on ? 'bg-green-500/15 text-green-300 hover:bg-green-500/25' : 'bg-white/5 text-white/60 hover:bg-white/10'
      }`}
      data-testid="push-toggle-btn"
    >
      <span className="flex items-center gap-2">
        {busy ? <BellRing className="w-4 h-4 animate-pulse" /> : on ? <Bell className="w-4 h-4" /> : <BellOff className="w-4 h-4" />}
        {on ? 'Push alerts on' : 'Enable push alerts'}
      </span>
      {on && (
        <span
          onClick={test}
          className="text-[11px] px-2 py-0.5 rounded bg-white/10 hover:bg-white/20"
          data-testid="push-test-btn"
        >
          Test
        </span>
      )}
    </button>
  );
};
